var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 5.06279 4.81279 0.25 10.75 0.25C16.6872 0.25 21.5 5.06279 21.5 11C21.5 16.9372 16.6872 21.75 10.75 21.75C4.81279 21.75 0 16.9372 0 11ZM10.75 1.75C5.64121 1.75 1.5 5.89121 1.5 11C1.5 16.1088 5.64121 20.25 10.75 20.25C15.8588 20.25 20 16.1088 20 11C20 5.89121 15.8588 1.75 10.75 1.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 6.88649C8.60704 6.75252 8.89294 6.75252 9.12499 6.88649L15.125 10.3505C15.357 10.4845 15.5 10.7321 15.5 11C15.5 11.268 15.357 11.5156 15.125 11.6495L9.12499 15.1135C8.89294 15.2475 8.60704 15.2475 8.375 15.1135C8.14295 14.9796 8 14.732 8 14.464V7.53601C8 7.26806 8.14295 7.02047 8.375 6.88649ZM9.5 8.83503V13.165L13.25 11L9.5 8.83503Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ec70d0a7896c294d0befb5c4ed7463bd.svg";
export { ForwardRef as ReactComponent };